// apps/web/src/widgets/summary-checklist/group-label.ts
//
// Phase 11.7 Plan 04 Task 0 — shared group-label resolver (Warning-2 seam).
//
// `resolveGroupLabel` (+ its `GroupLabelSource` type) was LIFTED out of
// summary-checklist/renderer.tsx so two render surfaces share ONE resolver
// without a copy-paste:
//   - Surface 1 (Plan 02) — option-tier-matrix / table column headers
//   - Surface 3 (this plan) — summary-checklist section headers
// This plan is Wave 1, so the module exists BEFORE Plan 02 (Wave 2) imports
// it. Mirrors the visible-when.ts lift precedent — except group-label.ts OWNS
// the definition (the resolver had no prior shared home). Pure module, no
// React import.
//
// 06-UI-REVIEW C-1: section/column header resolves a groupId to the
// recipe-declared OptionCategory.label (Phase 01.1 D-16..D-19). Internal
// markers `_ungrouped` / `_flat` render an empty label. Unknown ids fall back
// to the raw id so misconfiguration is visible instead of silent.
export type GroupLabelSource = ReadonlyArray<{ id: string; label: string }> | undefined;

export function resolveGroupLabel(groupKey: string, categories: GroupLabelSource): string {
  if (groupKey === "_ungrouped" || groupKey === "_flat") return "";
  return categories?.find((c) => c.id === groupKey)?.label ?? groupKey;
}
